import { render, staticRenderFns } from "./magnifier.vue?vue&type=template&id=403be9a8&"
import script from "./magnifier.vue?vue&type=script&lang=js&"
export * from "./magnifier.vue?vue&type=script&lang=js&"
import style0 from "./magnifier.vue?vue&type=style&index=0&id=403be9a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports